import React from 'react';
import { useNavigate } from 'react-router-dom';
import ParentNavigation from './ParentNavigation';
import VersionFooter from './VersionFooter';

const ParentLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Redirect to login
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar Navigation */}
      <ParentNavigation onLogout={handleLogout} />
      
      {/* Main Content */}
      <div className="flex-1 overflow-auto flex flex-col">
        <main className="flex-1">
          {children}
        </main>
        <VersionFooter />
      </div>
    </div>
  );
};

export default ParentLayout; 